import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from '../NotificationDrawer.module.scss';
export const NotificationFooterContent = ({ isOrderRow = false, dcn, formattedDate, formattedTime, }) => {
    return (_jsx("div", { className: `${styles['notification-footer']}`, "data-testid": "footer-notification", children: _jsxs("div", { className: isOrderRow
                ? `${styles['footer_order_change']}`
                : `${styles['notification_container']}`, children: [dcn ? _jsx("div", { className: `${styles['dcn_container']}`, children: dcn }) : null, _jsxs("div", { className: `${styles['date_container']}`, children: [formattedDate, " \u2022 ", formattedTime] })] }) }));
};
